import { BuilderSegmentService } from '../../services/BuilderSegmentService';
//import { agentConfiguration } from '../types';
//import { role } from '../types/instructions';
export class PaymentSegmentService extends BuilderSegmentService {
    setState(state) {
        this.state = state;
    }
    trackPaymentBlock(event, payload, success) {
        this.trackEvent(event, {
            ...payload,
            blockId: this.state.id,
            blockName: this.state.$title,
        }, success);
    }
}
